

// EC-849-Create a custom redux store to store the data
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";


export function getProductsState(state: CustomApplicationState) {
    return state.WhiteCap.products.products;
}

export function getAttributeTypeState(state: CustomApplicationState) {
    return state.WhiteCap.products.attributeTypeFacets;
}

export function getProductPriceByIdState(state: CustomApplicationState, id: string) {
    if(state.WhiteCap.products.productPriceProductId){
        return state.WhiteCap.products.productPriceProductId[id]
    }
    return null;
}




